module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/cms-panel.35180de3.svg";